import script from "./ValidationErrors.vue?vue&type=script&setup=true&lang=js"
export * from "./ValidationErrors.vue?vue&type=script&setup=true&lang=js"

export default script